import { render, staticRenderFns } from "./banner_v3_slider.vue?vue&type=template&id=587a6cc7&"
import script from "./banner_v3_slider.vue?vue&type=script&lang=js&"
export * from "./banner_v3_slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports